import type { GetProposalsRow, MarketConfig } from '@morfi/backend-sdk-v2/client';
import type { ProposalListItem } from './types';

export function adaptProposalRow(
  row: Omit<GetProposalsRow, 'outcomes' | 'topBackers'> & {
    readonly outcomes: readonly GetProposalsRow['outcomes'][number][];
  },
  config: MarketConfig | undefined,
): ProposalListItem {
  const proposer = row.proposer;
  return {
    marketType: row.marketType,
    partnerCreatorId: row.partnerCreatorId,
    associatedCreator: row.associatedCreator,
    pubkey: row.pubkey ?? '',
    title: row.title ?? '',
    description: row.description ?? '',
    category: row.category ?? '',
    location: row.location ?? null,
    status: row.status ?? '',
    totalFunded: row.totalFunded ?? '0',
    totalStaked: row.totalStaked,
    backerCount: row.numBackers ?? row.backerCount ?? 0,
    createdAt: row.createdAt ?? '',
    updatedAt: row.updatedAt ?? '',
    expiresAt: row.expiresAt ?? null,
    creator: proposer?.walletAddress ?? '',
    proposerDisplayName: proposer?.displayName ?? null,
    proposerHandle: proposer?.handle ?? null,
    proposerAvatarUrl: proposer?.avatarUrl ?? null,
    proposerAvatarNsfw: proposer?.avatarNsfw === true,
    proposerAvatarPreferences: proposer?.avatarPreferences ?? null,
    proposerConnectedProviders: [...(proposer?.connectedProviders ?? [])],
    coverImageUrl: row.coverImageUrl ?? null,
    coverImageNsfw: row.coverImageNsfw === true,
    numOutcomes: row.numOutcomes ?? 0,
    outcomes: Array.isArray(row.outcomes)
      ? row.outcomes.map((o) => ({
          outcomeIndex: o.outcomeIndex,
          label: o.label,
          imageUrl: o.imageUrl ?? '',
          imageNsfw: o.imageNsfw === true,
          funded: o.funded,
          fundedPercent: o.fundedPercent,
        }))
      : [],
    debateSpreadOk: row.debateSpreadOk ?? false,
    creationThreshold: config?.creationThresholdD6 ?? null,
    graduatedMarketPubkey: row.graduatedMarketPubkey ?? null,
    rejectionReason: null,
  };
}
